import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body pb-0" }
const _hoisted_2 = { class: "d-flex align-items-center mb-5" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1\"><div class=\"symbol symbol-45px me-5\"><img src=\"media/avatars/150-13.jpg\" alt=\"\"></div><div class=\"d-flex flex-column\"><a href=\"#\" class=\"text-gray-800 text-hover-primary fs-6 fw-bolder\">Carles Nilson</a><span class=\"text-gray-400 fw-bold\">Last week at 10:00 PM</span></div></div>", 1)
const _hoisted_4 = { class: "my-0" }
const _hoisted_5 = {
  type: "button",
  class: "\n              btn btn-sm btn-icon btn-color-primary btn-active-light-primary\n            ",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "mb-7" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-gray-800 mb-5" }, " Outlines keep you honest. They stop you from indulging in poorly thought-out metaphors about driving and keep you focused on the overall structure of your post ", -1)
const _hoisted_9 = { class: "d-flex align-items-center mb-5" }
const _hoisted_10 = {
  href: "#",
  class: "\n              btn btn-sm btn-light btn-color-muted btn-active-light-success\n              px-4\n              py-2\n              me-4\n            "
}
const _hoisted_11 = { class: "svg-icon svg-icon-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 22 ")
const _hoisted_13 = {
  href: "#",
  class: "\n              btn btn-sm btn-light btn-color-muted btn-active-light-danger\n              px-4\n              py-2\n            "
}
const _hoisted_14 = { class: "svg-icon svg-icon-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 59 ")
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "separator mb-4" }, null, -1)
const _hoisted_17 = { class: "position-relative mb-6" }
const _hoisted_18 = /*#__PURE__*/_createVNode("textarea", {
  class: "form-control border-0 p-0 pe-10 resize-none min-h-25px",
  "data-kt-autosize": "true",
  rows: "1",
  placeholder: "Reply.."
}, null, -1)
const _hoisted_19 = { class: "position-absolute top-0 end-0 me-n5" }
const _hoisted_20 = { class: "btn btn-icon btn-sm btn-active-color-primary pe-0 me-2" }
const _hoisted_21 = { class: "svg-icon svg-icon-3 mb-3" }
const _hoisted_22 = { class: "btn btn-icon btn-sm btn-active-color-primary ps-0" }
const _hoisted_23 = { class: "svg-icon svg-icon-2 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!

  return (_openBlock(), _createBlock("div", {
    class: ["card", _ctx.widgetClasses]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("button", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
            ])
          ]),
          _createVNode(_component_Dropdown3)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode("a", _hoisted_10, [
            _createVNode("span", _hoisted_11, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com012.svg" })
            ]),
            _hoisted_12
          ]),
          _createVNode("a", _hoisted_13, [
            _createVNode("span", _hoisted_14, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen030.svg" })
            ]),
            _hoisted_15
          ])
        ])
      ]),
      _hoisted_16,
      _createVNode("form", _hoisted_17, [
        _hoisted_18,
        _createVNode("div", _hoisted_19, [
          _createVNode("span", _hoisted_20, [
            _createVNode("span", _hoisted_21, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com008.svg" })
            ])
          ]),
          _createVNode("span", _hoisted_22, [
            _createVNode("span", _hoisted_23, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
            ])
          ])
        ])
      ])
    ])
  ], 2))
}